<template>
  <section class="fraud-types-section">
    <div class="section-container">

      <!-- 标题区域 -->
      <div class="header">
        <div class="tag">+ FRAUD INTELLIGENCE DATABASE</div>
        <h2 class="title">Fraud Types <span class="gradient">We Investigate</span></h2>

        <!-- 居中分割线 -->
        <div class="divider-container">
          <div class="line"></div>
          <span class="square-icon">[■]</span>
          <div class="line"></div>
        </div>
      </div>

      <!-- 终端风格数据库容器 -->
      <div class="database-container">
        <div class="db-header">
          <div class="dots">
            <span class="dot red"></span>
            <span class="dot yellow"></span>
            <span class="dot green"></span>
          </div>
          <div class="db-title">FRAUD_TYPES_database - ACTIVE_INVESTIGATION_CATEGORIES</div>
        </div>

        <!-- 表格区域 -->
        <div class="table-grid table-header">
          <div class="col-header">FRAUD TYPE</div>
          <div class="col-header">DESCRIPTION</div>
          <div class="col-header">RISK LEVEL</div>
          <div class="col-header">RECOVERY</div>
          <div class="col-header">AVG TIME</div>
        </div>

        <div v-for="(item, index) in fraudTypes" :key="index" class="table-grid table-row">
          <div class="col-type">{{ item.type }}</div>
          <div class="col-desc">{{ item.desc }}</div>
          <div class="col-risk">
            <span class="risk-badge" :class="item.risk.toLowerCase()">
              {{ item.risk.toUpperCase() }}
            </span>
          </div>
          <div class="col-recovery">
            <span class="check-icon">✓</span> Available
          </div>
          <div class="col-time">{{ item.time }}</div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'FraudTypesSection',
  data() {
    return {
      fraudTypes: [
        { type: 'Crypto Investment Scam', desc: 'Fake platforms promising guaranteed returns on crypto investments', risk: 'High', time: '5-7 days' },
        { type: 'Romance / Pig Butchering', desc: 'Long-term relationship-based fraud leading to crypto transfers', risk: 'High', time: '7-14 days' },
        { type: 'Exchange Hack / Wallet Theft', desc: 'Unauthorized access to wallets or exchange accounts', risk: 'High', time: '3-5 days' },
        { type: 'Phishing Attack', desc: 'Fake websites or emails used to steal private keys or credentials', risk: 'Med', time: '5-10 days' },
        { type: 'Rug Pull / Exit Scam', desc: 'Project developers abandon platform and take investor funds', risk: 'High', time: '7-21 days' },
        { type: 'Fake Broker / Forex Scam', desc: 'Unregulated brokers blocking withdrawals and disappearing', risk: 'High', time: '7-14 days' },
        { type: 'DeFi Smart Contract Exploit', desc: 'Malicious smart contracts draining user funds through DeFi protocols', risk: 'Med', time: '10-21 days' },
        { type: 'NFT Fraud', desc: 'Counterfeit NFT projects, marketplace fraud and stolen assets', risk: 'Low', time: '5-14 days' }
      ]
    };
  }
}
</script>

<style scoped>
.fraud-types-section {
  background-color: #070b14;
  padding: 60px 5%;
  color: #e2e8f0;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* 标题区域 */
.header {
  margin-bottom: 50px;
}

.tag {
  color: #4fd1c5;
  font-size: 0.75rem;
  letter-spacing: 2px;
  margin-bottom: 10px;
  font-weight: 500;
}

.title {
  font-size: 2.6rem;
  font-weight: 700;
  margin: 0 0 20px;
}

.gradient {
  background: linear-gradient(90deg, #4fd1c5, #8be9fd);
  -webkit-background-clip: text;
  color: transparent;
}

/* 分割线 */
.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(79, 209, 197, 0.2);
}

.divider-container .square-icon {
  color: #4fd1c5;
  font-size: 0.8rem;
  font-family: monospace;
  margin: 0 15px;
}

/* 数据库容器 */
.database-container {
  background: #0d1117;
  border: 1px solid rgba(79, 209, 197, 0.2);
  border-radius: 10px;
  overflow: hidden;
}

.db-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(79, 209, 197, 0.2);
  padding: 15px 20px;
}

.dots {
  display: flex;
  gap: 8px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.dot.red {
  background: #ff5f56;
}

.dot.yellow {
  background: #ffbd2e;
}

.dot.green {
  background: #27c93f;
}

.db-title {
  color: #94a3b8;
  font-family: monospace;
  font-size: 0.8rem;
}

/* 表格主体 */
.table-grid {
  display: grid;
  grid-template-columns: 2fr 4fr 1fr 1.5fr 1.5fr;
  gap: 15px;
  align-items: center;
  padding: 15px 20px;
}

.table-header {
  border-bottom: 1px solid rgba(79, 209, 197, 0.2);
}

.col-header {
  color: #4fd1c5;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
}

.table-row {
  border-bottom: 1px solid rgba(37, 48, 69, 0.5);
  font-size: 0.9rem;
}

.table-row:last-child {
  border-bottom: none;
}

.col-type {
  font-weight: 600;
  color: #ffffff;
}

.col-desc {
  color: #94a3b8;
}

/* 风险等级徽章 */
.risk-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 1px;
  border: 1px solid;
  text-align: center;
}

.risk-badge.high {
  color: #ff7b72;
  border-color: #ff7b72;
  background: rgba(255, 123, 114, 0.1);
}

.risk-badge.med {
  color: #fbbf24;
  border-color: #fbbf24;
  background: rgba(251, 191, 36, 0.1);
}

.risk-badge.low {
  color: #4fd1c5;
  border-color: #4fd1c5;
  background: rgba(79, 209, 197, 0.1);
}

/* 恢复列 */
.col-recovery {
  color: #4fd1c5;
  display: flex;
  align-items: center;
  gap: 8px;
}

.check-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  border: 1px solid #4fd1c5;
  border-radius: 50%;
  font-size: 0.7rem;
}

.col-time {
  color: #94a3b8;
}

/* 响应式适配：移动端变为卡片堆叠 */
@media (max-width: 768px) {
  .title {
    font-size: 2.2rem;
  }

  .db-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .db-title {
    font-size: 0.7rem;
  }

  .table-header {
    display: none;
  }

  .table-grid {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 20px;
  }

  .col-type {
    font-size: 1.1rem;
    color: #4fd1c5;
  }

  .col-desc {
    font-size: 0.85rem;
  }

  .col-risk {
    margin-top: 5px;
  }

  .col-recovery,
  .col-time {
    font-size: 0.85rem;
  }
}
</style>